import React, { useEffect, useState, useRef } from "react";
import Navbar from "../components/Navbar.js";
import Footer from "../components/Footer.js";
import BannerImage from "../components/img/paediatrics-banner.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import axios from 'axios';
import "../styles/pages.css";
import { FaChevronRight, FaCircleArrowRight } from "react-icons/fa6";
import { useNavigate } from 'react-router-dom';

function Paediatrics () {
  const [activeSection, setActiveSection] = useState("overview");
  const [isFixed, setIsFixed] = useState(false);
  const sectionsRef = {
    overview: useRef(null),
    treatment: useRef(null),
    facilities: useRef(null),
    development: useRef(null),
    doctors: useRef(null),
  };
  const sidebarRef = useRef(null);
  const contentRef = useRef(null);
  const footerRef = useRef(null);

  const handleScroll = () => {
    const sections = ["overview", "treatment", "facilities", "development", "doctors"];
    let currentSection = "";
    let setFix = false;
    for (let section of sections) {
      const ref = sectionsRef[section].current;
      const { top, bottom } = ref.getBoundingClientRect();
      const isInView =
        top <= window.innerHeight / 2 && bottom >= window.innerHeight / 2;
      if (top < 85) {
        setFix = true;
      } else {
        setFix = false;
      }
      if (isInView) {
        currentSection = section;
      }
    }
    setIsFixed(setFix);
    setActiveSection(currentSection);
  };

  const scrollToSection = (section) => {
    const sectionElement = sectionsRef[section].current;
    if (sectionElement) {
      const offsetTop = sectionElement.getBoundingClientRect().top + window.scrollY;
      const headerOffset = 100; // Adjust this value to match the height of your fixed header or sidebar
      window.scrollTo({
        top: offsetTop - headerOffset,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    handleScroll(); // Trigger once on load
    window.addEventListener("scroll", handleScroll);
  }, []);

  const [doctors, setDoctors] = useState([]);
  const [error, setError] = useState(null);
  const filteredDoctors = doctors.filter(doctor => doctor.specialization === "Paediatrics");

  useEffect(() => {
    const fetchDoctors = async () => {
      try {
        const response = await axios.get(`https://caritasmathahospital.com/wp-content/themes/my_react_theme/api/get_doctors.php`);
        console.log("Doctors API Response:", response.data);
        setDoctors(response.data);
      } catch (error) {
        console.error("Error fetching doctors:", error);
      }
    };
    fetchDoctors();
  }, []);

  const paediatricSurgery = doctors.filter(doctor => doctor.specialization === "Paediatric Surgery");

  const navigate = useNavigate();
  
  const handleDoctorClick = (doctor) => {
    navigate(`/doctor/${doctor.id}`, { state: { doctor } })
  };

  return (
    <div>

        {/* Navbar starts here  */}

            <Navbar />

        {/* Navbar ends here */}

        <section className="page-section">
            <div className="section-content">
                <p className='page-heading'>Paediatrics & Paediatrics Surgery</p>

                <div className="d-none d-md-block"> {/*Visible on desktop, hidden on mobile */}
                    <p className="page-subtitle">
                        Comprehensive Paediatric Care and Surgical Interventions 
                        <br/>
                        Tailored for Children.
                    </p>
                </div>

                <div className="d-md-none mb-2"> {/* Visible on mobile, hidden on desktop */}
                    <p className="page-subtitle">
                        Comprehensive Paediatric Care and Surgical Interventions Tailored for Children.
                    </p>
                </div>

                <div className="page-box">
                    <div className="box-content">
                        <p>Caritas Matha Hospital's Paediatrics & Paediatrics Surgery department is committed to delivering exceptional care for children and adolescents. Our dedicated team of paediatricians and paediatric surgeons provides comprehensive medical treatments and surgical interventions tailored to meet the unique needs of young patients.</p>
                    </div>
                    <div className="box-image">
                        <img src={BannerImage} alt="Paediatrics & Paediatrics Surgery Banner"/>
                    </div>
                </div>
            </div>
        </section>
        <section className="dept-section">
            <div
            ref={sidebarRef}
            className={`sidebar-title ${!isFixed ? "fixed" : ""}`}
            >
            {["overview", "treatment", "facilities", "development", "doctors"].map((section) => (
                <p
                key={section}
                className={`title ${activeSection === section ? "active" : ""}`}
                onClick={() => scrollToSection(section)}
                >
                {section.charAt(0).toUpperCase() + section.slice(1)}
                {activeSection === section && (
                    <FontAwesomeIcon
                    icon={faChevronRight}
                    className="chevron-icon"
                    />
                )}
                </p>
            ))}
            </div>
            <div ref={contentRef} className="contents">
                <div ref={sectionsRef.overview} className="overview-content">
                    <p className="content-heading">Overview</p>
                    {/* Overview content here */}
                    <p>The Paediatrics & Paediatrics Surgery department at Caritas Matha Hospital provides comprehensive care for infants, children, and adolescents. Our dedicated team of pediatricians and pediatric surgeons is committed to delivering high-quality medical and surgical care in a child-friendly environment. We prioritize the health, well-being, and development of every child, offering personalized and compassionate care.</p>

                    <p>At Caritas Matha Hospital, we understand that children have unique medical needs that require specialized attention. Our team is skilled in addressing a wide range of pediatric conditions, from routine health issues to complex surgical cases. We work closely with families to ensure that they are fully informed and involved in their child's care, fostering a supportive and reassuring experience.</p>

                    <p>Our department is equipped with state-of-the-art technology and facilities designed specifically for pediatric care. We provide a nurturing environment where children can feel comfortable and safe. Our commitment to continuous improvement and education ensures that we stay at the forefront of pediatric medicine, offering the latest treatments and interventions to promote the best possible outcomes for our young patients.</p>

                </div>
                <div ref={sectionsRef.treatment} className="treatment-content">
                    <p className="content-heading">Treatment</p>
                    {/* Treatment content here */}
                    
                    
                    <span className="sub-heading">General Paediatrics : </span>
                    <p></p>
                    <ul>
                        <li>
                            <span className="subtitle">Preventive Care : </span>Routine check-ups, vaccinations, and health screenings to ensure optimal growth and development.</li>
                        <br/>

                        <li>
                            <span className="subtitle">Acute Care : </span>Treatment for common childhood illnesses, infections, and injuries.</li>
                        <br/>

                        <li>
                            <span className="subtitle">Chronic Condition Management : </span>Ongoing care for chronic conditions such as asthma,diabetes, allergies, Neuro developement problems like Autism spectrum disordes, learning disability, ADHD, Behavoiral problems, Cognitive impairment, Cerebral palsy, Seizure disorder.</li>
                        <br/>

                        <li>
                            <span className="subtitle">Nutritional Guidance : </span>Expert advice on nutrition and healthy eating habits for children.</li>
                        <br/>

                    </ul>

                    <span className="sub-heading">Paediatrics Surgery : </span>
                    <p></p>
                    
                    <ul>

                        <li>
                            <span className="subtitle">Congenital Anomalies : </span>Surgical correction of congenital anomalies such as cleft lip and palate, congenital heart defects, and gastrointestinal malformations.</li>
                        <br/>

                        <li>
                            <span className="subtitle">Emergency Surgeries : </span>Prompt surgical intervention for emergencies like appendicitis, hernias, and trauma.</li>
                        <br/>

                        <li>
                            <span className="subtitle">Minimally Invasive Surgery : </span>Advanced laparoscopic and thoracoscopic procedures to minimize pain and recovery time.</li>
                        <br/>

                        <li>
                            <span className="subtitle">Urological Surgeries : </span>Treatment for conditions like hypospadias, undescended testes, and vesicoureteral reflux.</li>
                        <br/>

                        <li>
                            <span className="subtitle">Orthopedic Surgeries : </span>Correction of congenital and acquired orthopedic conditions, including clubfoot, scoliosis, and fractures.</li>
                        <br/>

                    </ul>

                </div>
                <div ref={sectionsRef.facilities} className="facilities-content">
                    <p className="content-heading">Facilities</p>
                    {/* Facilities content here */}
                    
                    <ul>
                        <li>
                            <span className="subtitle">Child-Friendly Environment : </span>Our department is designed to be welcoming and comforting for children and their families, with play areas and colorful decor.</li>
                        <br/>

                        <li>
                            <span className="subtitle">Advanced Diagnostics : </span>State-of-the-art diagnostic facilities, including pediatric imaging and laboratory services, for accurate and timely diagnosis.</li>
                        <br/>

                        <li>
                            <span className="subtitle">Specialist Care : </span>Access to a multidisciplinary team of specialists, including pediatric cardiologists, neurologists, endocrinologists, and more.</li>
                        <br/>

                        <li>
                            <span className="subtitle">Neonatal Intensive Care Unit (NICU) : </span>A fully equipped NICU for the care of premature and critically ill newborns, staffed by experienced neonatologists and nurses.</li>
                        <br/>

                        <li>
                            <span className="subtitle">Pediatric Intensive Care Unit (PICU) : </span>Advanced PICU for the care of critically ill children, with round-the-clock monitoring and support.</li>
                        <br/>

                        <li>
                            <span className="subtitle">Outpatient Services : </span>Convenient outpatient clinics for routine check-ups, follow-up visits, and specialist consultations.</li>
                        <br/>

                        <li>
                            <span className="subtitle">Surgical Suites : </span>Modern operating theaters equipped with the latest technology for pediatric surgeries.</li>
                        <br/>

                        <li>
                            <span className="subtitle">Rehabilitation Services : </span>Comprehensive rehabilitation services, including physical therapy, occupational therapy, and speech therapy, to support recovery and development.</li>
                        <br/>

                        <li>Paediatric orthopaedic and sports injuries</li>
                        <br/>

                        <li>Paediatric burns</li>
                        <br/>

                    </ul>

        
                </div>

                <div ref={sectionsRef.development} className="development-clinic">
                    <p className="content-heading">Development Clinic</p>
                    {/* Development Clinic Here */}

                    <p>
                        <span className="subtitle">1. Well Child Clinic </span>
                        <br />
                        Routine developmental assessment for children. School readiness evaluation for pre schoolers
                    </p>

                    <p>
                        <span className="subtitle">2. High Risk Baby Clinic</span>
                        <br />
                        For those kids who are having risk factors for developmental problems.
                    </p>

                    <p>
                        <span className="subtitle">3. Child Development Clinic </span>
                        <br />
                        Management of neuro developmental disorders including speech and language delay, delayed mile stones,locomotory disorders including cerebral palsy, Autism,ADHD, Behavioral disorders, Specific learning disorders etc.
                    </p>

                    <p>
                        <span className="subtitle">4. Pediatric Asthma and Allergy Clinic </span>
                        <br />
                        Diagnosis, treatment and follow up of children with asthma.
                        <br/>
                        Management of allergic rhinitis,skin allergies,food allergies and comorbidities.
                    </p>

                    <p>
                        <span className="subtitle">5. Growth Clinic</span>
                        <br />
                        Growth and development assessment ( 0_18 yrs)
                    </p>
                    <br/>
                    <p>Management of growth problems _ under and over weight, Short stature, Nutritional deficiency disorders, Dietary interventions and counseling</p>

                </div>

                <div ref={sectionsRef.doctors} className="doctors">
                    <p className="content-heading">Doctors</p>

                    {error && <p>{error}</p>}
                    {filteredDoctors.length > 0 ? (
                        <div className='doctorbox-container'>
                            {filteredDoctors.map(doctor => (
                                 <div key={doctor.id} className="doctorbox">
                                    <div className="doctor-box">
                                        <img src={doctor.image_url} className='doctor-img' onClick={() => handleDoctorClick(doctor)} style={{ cursor: "pointer" }}/>
                                        <div className='doctor-details'>
                                            <h4 onClick={() => handleDoctorClick(doctor)} style={{ cursor: "pointer" }}>{doctor['name']}</h4>
                                            <p>{doctor['designation']}</p>
                                            <p>{ doctor.available_time }</p>
                                            <br/>
                                            {parseInt(doctor.appointment_enabled) === 1 && (
                                                <p>
                                                    <a href="https://booking.caritasmathahospital.com/OnlineAppointmentBooking/OnlineAppointmentBooking.aspx" target="_blank" rel="noopener noreferrer" >
                                                        Book An Appointment <FaChevronRight />
                                                    </a>
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                    <div className='arrow-section'>
                                        <FaCircleArrowRight className='right-circle-arrow' onClick={() => handleDoctorClick(doctor)} style={{ cursor: "pointer" }}/>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        !error && <p>No doctors available in this department.</p>
                    )}

                    <h5 className="dept-heading">Paediatric Surgery</h5>
                    <div className='doctorbox-container'>
                        {paediatricSurgery.map(doctor => (
                            <div key={doctor.id} className="doctorbox">
                                <div className="doctor-box">
                                    <img src={doctor.image_url} className='doctor-img' onClick={() => handleDoctorClick(doctor)} style={{ cursor: "pointer" }}/>
                                    <div className='doctor-details'>
                                        <h4 onClick={() => handleDoctorClick(doctor)} style={{ cursor: "pointer" }}>{doctor['name']}</h4>
                                        <p>{doctor['designation']}</p>
                                        <p>{ doctor.available_time }</p>
                                        <br/>
                                        {parseInt(doctor.appointment_enabled) === 1 && (
                                            <p>
                                                <a href="https://booking.caritasmathahospital.com/OnlineAppointmentBooking/OnlineAppointmentBooking.aspx" target="_blank" rel="noopener noreferrer" >
                                                    Book An Appointment <FaChevronRight />
                                                </a>
                                            </p>
                                        )}
                                    </div>
                                </div>
                                <div className='arrow-section'>
                                    <FaCircleArrowRight className='right-circle-arrow' onClick={() => handleDoctorClick(doctor)} style={{ cursor: "pointer" }}/>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>

        {/* Footer Starts here */}

            <Footer ref={footerRef} />

        {/* Footer ends here */}
    </div>
  );
}

export default Paediatrics;
